import { render, staticRenderFns } from "./product_list.vue?vue&type=template&id=738cd3a8&scoped=true"
import script from "./product_list.vue?vue&type=script&lang=js"
export * from "./product_list.vue?vue&type=script&lang=js"
import style0 from "./product_list.vue?vue&type=style&index=0&id=738cd3a8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738cd3a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('738cd3a8')) {
      api.createRecord('738cd3a8', component.options)
    } else {
      api.reload('738cd3a8', component.options)
    }
    module.hot.accept("./product_list.vue?vue&type=template&id=738cd3a8&scoped=true", function () {
      api.rerender('738cd3a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/tasting_wine_management/blending_policy_management/form/product_list.vue"
export default component.exports